import React from 'react';
import styled from 'styled-components';

import { BaseProps } from '@make-software/cspr-design';

/* eslint-disable-next-line */
export interface DetailsTableRowProps extends BaseProps {
  hideBorder?: boolean;
}

const StyledTableRow = styled.tr<{ hideBorder?: boolean }>(
  ({ theme, hideBorder = false, onClick }) => ({
    ':not(:first-child):after': {
      content: "''",
      position: 'absolute',
      left: 20,
      right: 20,
      top: 0,
      ...(!hideBorder && {
        borderBottom: theme.border.tableRowSeparator,
      }),
    },
    position: 'relative',
    // safari hack for table rows' borders
    perspective: 1000,
    transform: 'translateZ(0)',
    ...(onClick && {
      cursor: 'pointer',
      ':hover, :active': {
        background: theme.styleguideColors.fillSecondary,
      },
    }),
  })
);

export function DetailsTableRow(props: DetailsTableRowProps) {
  return <StyledTableRow {...props} />;
}

export default DetailsTableRow;
